<template>
    <section v-if="slice.primary.theme === 'trends'">
        <TrendsTable :column-items="slice.items" :rows="tableRows" :subtitle="slice.primary.subtitle" :title="slice.primary.title" />
    </section>
    <section v-else class="table-slice">
        <div class="content">
            <table>
                <thead>
                    <tr>
                        <th v-for="(item, index) in slice.items" :key="index">
                            <PrismicRichText :field="item.columnHead" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in tableRows" :key="index">
                        <td v-for="(item, i) in row" :key="i">
                            <PrismicRichText :field="item" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script setup lang="ts">
    import type {RichTextField} from '@prismicio/types';
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {TableSliceSlice} from '@prismicio-types';
    import TrendsTable from '~/components/trends/TrendsTable.vue';

    const props = defineProps(getSliceComponentProps<TableSliceSlice>());
    const tableRows: Array<Array<RichTextField>> = [];
    for (let i = 0; i < Math.max(...props.slice.items.map((item) => item.rows.length ?? 0)); i++) {
        tableRows.push(
            props.slice.items.map(
                (item) => [item.rows[i] ? {...item.rows[i], type: 'paragraph'} : {type: 'paragraph', text: '', spans: []}] as RichTextField,
            ),
        );
    }
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .table-slice {
        @include content-width($article-max-width);

        .content {
            max-width: 100%;
            overflow: auto;
        }

        table {
            border-collapse: separate;
            border-spacing: 0;

            th,
            td {
                padding: var(--joy-core-spacing-3);
                border: solid 1px var(--joy-color-neutral-30);
            }

            th {
                background-color: var(--joy-color-primary-50);

                &:first-of-type {
                    border-top-left-radius: var(--joy-core-radius-3);
                }

                &:last-child {
                    border-top-right-radius: var(--joy-core-radius-3);
                }

                * {
                    color: var(--joy-color-neutral-0);
                    font-family: var(--joy-font-family-title);
                    font-weight: 800;
                    font-size: var(--joy-font-size-primary-600);
                }
            }

            td {
                * {
                    font-size: var(--joy-font-size-primary-400);
                }
            }

            tr {
                &:last-child {
                    td:first-child {
                        border-bottom-left-radius: var(--joy-core-radius-3);
                    }

                    td:last-child {
                        border-bottom-right-radius: var(--joy-core-radius-3);
                    }
                }
            }
        }
    }
</style>
